var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isMultiple)?_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltip),expression:"tooltip"}],class:[{ 'dashed-underline': _vm.isMultiple }],attrs:{"data-cy":_vm.dataCy}},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_c('span',{attrs:{"title":_vm.label,"data-cy":_vm.dataCy}},[_vm._v(_vm._s(_vm.label))])
}
var staticRenderFns = []

export { render, staticRenderFns }